import Vue from 'vue';
import Component from 'vue-class-component';

// Register the router hooks with their names
Component.registerHooks([
    // 'updated',
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

import './componentHooks'; // <-- Needs to be first
import axios from 'axios';
import VueAxios from 'vue-axios';
// import jwt_decode from 'jwt-decode';
import Vuex from 'vuex';

// import InjectionKey from 'vue';
// import { createStore, Store } from 'vuex'

// import VueSimpleAlert from 'vue-simple-alert';
import createCache from 'vuex-cache';
import App from './App.vue';
import router from './router';
import 'vue-material-design-icons/styles.css';
import VModal from 'vue-js-modal';
import 'vuetify/dist/vuetify.min.css';
import vuetify from './plugins/vuetify';
import { Vue2Storage } from 'vue2-storage';

import VueCompositionAPI from "@vue/composition-api";
// import "@jsonforms/vue2-vanilla/vanilla.css";

import base64url from 'base64url';
import { encode } from 'js-base64';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

import { HaystackLogin } from './haystack_auth';
import VueRouter from 'vue-router';

import { sprintf } from 'sprintf-js';
import * as common from '@/common';

import { DateTime } from "luxon";

// const auth_module = require('./haystack-auth-node/index');
// import './haystack-auth-node/auth/AuthClientContext';
// import * as auth_module from './haystack-auth-node/index';

Vue.use(VueCompositionAPI);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(Vue2Storage, {
  prefix: 'profile_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000, // 24 hours
});

Vue.config.productionTip = false;
// Vue.config.devtools = true;
// Vue.config.performance = true;

// export const BMOS_URL = 'https://bmos.carnegosystems.net';
// export const window.VUE_BMOS_WEB_API = 'http://127.0.0.1:1338';
// export const window.VUE_BMOS_WEB_API = 'http://192.168.1.218:1338';
// export const window.VUE_BMOS_WEB_API = 'https://localhost:1338';

// export interface State {
//   jwt: string;
//   layout: string;
//   currentSiteGroup: ISiteGroup;
// };

// export const key: InjectionKey<Store<State>> = Symbol()

export interface IHaystackTag {
  point: string;
  haystackkey: string;
  haystackvalue: string;
}

export interface ISiteGroup {
  id: number;
  namespace: string;
  settings: object;
}

export function instanceOfISiteGroup(object: any): object is ISiteGroup {
  return 'namespace' in object;
}

export interface IApp {
  id: number;
  name: string;
}

export interface IDataValue {
  dt: DateTime;
  value: number;
}

export interface IHaystackUser {
  id: number;
  username: string;
  email: string;
  is_admin: string;
  user_type: string;
  avatar: string;
  root_ref: string;
  apps: IApp[];
  site_groups: ISiteGroup[];
  site_ids: number[];
}
export interface IPointRef {
  ref: string;
  name: string;
}

export interface IRefInfo {
  carnego_importer: string;
  namespace: string;
  ref: string;
  name: string;
  project_name: string;
  dis: string;
  hisTotalized: boolean;
  carnego_organisation_ref: string;
  carnego_site_group_ref: string;
  site_ref: string;
  equip_ref: string;
  organisation_namespace: string;
  site_group_namespace: string;
  site_namespace: string;
  equip_namespace: string;
  start_datetime: string;
  carnego_ip: string;
  point_tags: object;
  site_group_tags: object;
  site_tags: object;
  equip_tags: object;
}
export interface IRefLastValue {
  ref: string;
  organisation_ref: string;
  site_group_ref: string;
  site_ref: string;
  equip_ref: string;
  organisation_namespace: string;
  site_group_namespace: string;
  site_namespace: string;
  equip_namespace: string;
  point_namespace: string;
  timestamp: DateTime;
  value: number;
}
export interface IProfilePoints {
  appliance_points: string[];
  comfort_points: string[];
  heating_points: string[];
  hotwater_points: string[];
}
export interface IProfileSitePoints {
  site_ref: string;
  appliance_points: IPointRef[];
  comfort_points: IPointRef[];
  heating_points: IPointRef[];
  hotwater_points: IPointRef[];
}
export interface IMonthlyStat {
  reference: string;
  month: string;
  number_of_days: number;
  sum_of_daily_differences: number;
  sum_of_max_daily_values: number;
  average_of_daily_differences: number;
  average_of_max_daily_values: number;
  min_of_min_daily_values: number;
  max_of_max_daily_values: number;
}
export interface IStatForTimespan {
  reference: string;
  number_of_values: number;
  number_of_values_non_zero: number;
  average_value: number;
  average_value_non_zero: number;
  average_of_daily_differences: number;
  average_of_daily_differences_non_zero: number;
  min_value: number;
  min_value_non_zero: number;
  min_of_daily_differences: number;
  min_of_daily_differences_non_zero: number;
  max_value: number;
  max_of_daily_differences: number;
  max_of_daily_differences_non_zero: number;
}

export interface IScript {
  name: string;
  toml: string;
}

export interface IScriptInstance {
  id: number;
  name: string;
  description: string;
}

export interface IPointHaystackTag {
  point: string;
  haystackkey: string;
  haystackvalue: string;
}

export function strip_surrounding_quotes(s: string): string {

  if (s === undefined) {
    return '';
  }

  if (s.startsWith('"') && s.endsWith('"')) {
    return s.substring(1, s.length - 1);
  }

  return s;
}

export function strip_surrounding_square_brackets(s: string): string {

  if (s === undefined) {
    return '';
  }

  if (s.startsWith('[') && s.endsWith(']')) {
    return s.substring(1, s.length - 1);
  }

  return s;
}

export function add_surrounding_escaped_quotes(s: string): string {
  return '\\"' + s + '\\"';
}


export function escaped_string_json_to_object(s: string): any {
  const tmp_str = s.substring(1, s.length - 1);
  const tmp_unquoted_str = tmp_str.replace(/\\"/g, '"');
  return JSON.parse(tmp_unquoted_str);
}

export function array_to_string(array: any[]): string {
  let string_array = '[';

  for (const i of array) {
    string_array = string_array.concat(i);
    string_array = string_array.concat(',');
  }

  string_array = string_array.substring(0, string_array.length - 1);
  string_array = string_array.concat(']');

  return string_array;
}

function parse_refs_in_header_line_for_his_read(line: string) {
  // "ver:"3.0" id:[@619766,@619836,@619837,@619807,@619493] hisStart:2020-03-31T00:00:00.000 UTC hisEnd:2021-03-31T23:59:59.000 UTC"
  const parts = line.split(' ');
  let id_str: string | undefined;

  for (const p of parts) {
    if (p.includes('id:')) {
      id_str = p;
    }
  }

  if (id_str !== undefined) {
    // need to parse id:[@619766,@619836,@619837,@619807,@619493]
    const array_parts = id_str.split(':');
    if (array_parts.length !== 2) {
      return undefined;
    }
    const refs = array_parts[1];

    if (refs.charAt(0) === '@') {
      return [refs];
    }

    if (refs.charAt(0) === '[') {
      return refs.slice(1, -1).split(',');
    }

    return undefined;
  }

  return undefined;
}

function parse_hist_read_data_into_map(data: string, ref_map: Map<string, string>, data_map: Map<string, IDataValue[]>) {

  if (data !== undefined && data !== null) {

    const lines = data.split('\n');
    const refs = parse_refs_in_header_line_for_his_read(lines[0]);
    const data_lines = lines.slice(2);

    if (refs === undefined) {
      return data_map;
    }

    for (const line of data_lines) {

      if (line.includes('NaN')) {
        continue;
      }

      const fields = line.split(',');

      let count = 0;
      for (const f of fields.slice(1)) {

        const reference = refs[count];
        const namespace = ref_map.get(reference);

        if (namespace === undefined) {
          continue;
        }

        count++;
        let tmp = data_map.get(namespace);

        if (tmp === undefined) {
          data_map.set(namespace, []);
          tmp = data_map.get(namespace);
        }

        if (tmp === undefined) {
          continue;
        }

        tmp.push({dt: DateTime.fromFormat(fields[0], "yyyy-MM-dd'T'HH:mm:ss.SSS z").toUTC(), value: parseFloat(f)});
      }

    }
  }
}

export async function redirect_to_homepage(store: any, router: any) {
  const userInfo: IHaystackUser = await store.cache.dispatch('requestUserInfo');
  console.log('user info: ', userInfo);

  let project_name: string;
  let homepage: string;

  await store.dispatch('setUpDefaultUserSiteGroup', userInfo);
  const current_site_group: ISiteGroup = await store.getters.CurrentSiteGroup;

  if (userInfo.is_admin === 'T') {
    homepage = current_site_group.settings['homepage'];
    store.commit('setLayout', 'default-layout');
  } else {

      console.info("homepage redirect");
      project_name = userInfo.site_groups[0].settings['name'];
      console.info("homepage redirect project_name", project_name);
      homepage = userInfo.site_groups[0].settings['homepage'];

      console.info("Path");
      console.info(router.history.current.path);
      console.info(homepage);

      if(router.history.current.path !== homepage) {
        console.info("homepage redirect homepage", homepage);
        store.commit('setLayout', project_name + '-layout');
        console.info("homepage redirect router push", homepage);
        router.push({ path: homepage });
      }
  }
}

const test_json = JSON.parse('{"test":{"name":"ventive","organisation_name":"ventive","project_name":"prototype","campus_name":"nottingham","interval":60,"conn":{"user":"bmos","password":"cms823nvc","host":"carneab4.memset.net","port":5432,"database":"bmos"},"sites":{"vn_proto":{"name":"vn_proto","enable":true,"plot":"2","equip":[{"name":"ventive_home","enable":true,"ip":"178.211.198.162","port":1003,"points":[{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"circ_pump_speed","dis":"Circ_pu","order":"DCBA","reg_type":"holding","register":94,"units":"%","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"setpoint_indoor_temp","dis":"Tin_cmp","order":"DCBA","reg_type":"holding","register":114,"units":"ºC","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"setpoint_co2","dis":"Tco2Cmp","order":"DCBA","reg_type":"holding","register":120,"units":"ppm","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"setpoint_hp_temp_threshold","dis":"TcomOFF","order":"DCBA","reg_type":"holding","register":122,"units":"ºC","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"temp_living_room","dis":"Livin_1","order":"DCBA","reg_type":"holding","register":150,"units":"ºC","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"temp_kitchen","dis":"Kitch_2","order":"DCBA","reg_type":"holding","register":152,"units":"ºC","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"temp_bedroom1","dis":"Bed1_3","order":"DCBA","reg_type":"holding","register":154,"units":"ºC","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"temp_bedroom2","dis":"Bed2_4","order":"DCBA","reg_type":"holding","register":156,"units":"ºC","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"float","uid":1,"enable":true,"auto_convert":false,"name":"occupancy_combined","dis":"Occupan","order":"DCBA","reg_type":"holding","register":170,"units":"none","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"boolean","uid":1,"enable":true,"auto_convert":false,"name":"occupancy_living_room","dis":"Liv_1","order":"DCBA","reg_type":"holding","register":172,"units":"boolean","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"boolean","uid":1,"enable":true,"auto_convert":false,"name":"occupancy_kitchen","dis":"Kitc_2","order":"DCBA","reg_type":"holding","register":174,"units":"boolean","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"boolean","uid":1,"enable":true,"auto_convert":false,"name":"occupancy_bedroom1","dis":"Bed_3","order":"DCBA","reg_type":"holding","register":176,"units":"boolean","scale":1.0,"interval":160},{"supports_contiguous_modbus_reads":true,"data_type":"boolean","uid":1,"enable":true,"auto_convert":false,"name":"occupancy_bedroom2","dis":"Bed_4","order":"DCBA","reg_type":"holding","register":178,"units":"boolean","scale":1.0,"interval":160}]}]}}}}');

// const test_json = JSON.parse('');

const store = new Vuex.Store({
  plugins: [createCache()],
  state: {
    jwt: localStorage.getItem('t'),
    layout: 'login-layout',
    currentSiteGroup: undefined,
    // changedConfigs: {},
  },
  mutations: {
    updateToken(state, newToken) {
      console.log('setting token to: ' + newToken);
      localStorage.setItem('t', newToken);
      console.log('localStorage.getItem(t): ' + localStorage.getItem('t'));
      state.jwt = newToken;
    },
    removeToken(state) {
      console.log('removing token');
      localStorage.removeItem('t');
      state.jwt = null;
      state.layout = 'login-layout';
    },
    setLayout(state, payload) {
      state.layout = payload;
    },
    setCurrentSiteGroup(state, payload) {

      if(!instanceOfISiteGroup(payload)) {
        console.error('incorrect site group type passed');
      }

      localStorage.setItem('site_group', JSON.stringify(payload));
      console.log("setting site_group", payload);
      state.currentSiteGroup = payload;
    },
    clearCurrentSiteGroup(state, payload) {

      localStorage.removeItem('site_group');
      state.currentSiteGroup = undefined;
    },
    // setConfig(state, payload: {}) {
    //     state.changedConfigs = payload;
    // },
    // updateChangedConfigs(state, infos: {}) {

    //   // debugger;

    //   // // Merge two objects
    //   // state.changedConfigs = {
    //   //     ...state.changedConfigs,
    //   //     ...infos,
    //   // };

    //   state.changedConfigs = merge(state.changedConfigs, infos);
    // },
  },
  getters: {
    isAuthenticated(state) {
      console.log('isAuthenticated: ' + state.jwt);
      // return (localStorage.getItem('t') != null);
      return state.jwt != null;
    },
    Jwt(state) { return state.jwt; },
    AuthHeader(state) { return 'BEARER authToken=' + state.jwt; },
    DefaultHeaders(state, getters) {

      const parts = window.location.host.split('.', 1);
      let org = 'default';

      if (parts.length === 1) {
        org = parts[0];
      }

      let current_site_group = getters.CurrentSiteGroup;
      let site_group_name = 'default';
      
      // if (current_site_group !== undefined && current_site_group !== null && current_site_group.namespace && current_site_group.settings) {
      //   const site_group_settings = current_site_group.settings;

      //   // const site_group_settings = escaped_string_json_to_object(fields[2]);
      //   // site_group_name = split_namespace_name(getters.CurrentSiteGroup.namespace);
      //   if ('name' in site_group_settings) {
      //     site_group_name = site_group_settings['name'];
      //   }
      // }

      if (current_site_group !== undefined && current_site_group !== null && current_site_group.namespace) {
        site_group_name = current_site_group.namespace;
      }

      const headers = {
        headers: { 'Content-Type': 'text/plain', 'authorization': 'BEARER authToken=' + state.jwt,  'organisation': org, 'site_group_namespace': site_group_name},
      };

      console.log(headers);

      return headers;
    },
    Layout(state) { return state.layout; },
    CurrentSiteGroup(state) { 

      // First try store if that fails check localStorage
      const site_group = state.currentSiteGroup;

      if (site_group !== undefined) {
        return site_group;
      }

      const tmp = localStorage.getItem('site_group');
      if (tmp !== undefined && tmp !== null) {
        return JSON.parse(tmp);
      }
      
      return undefined;
    },
    // ChangedConfigs(state) {  return { ...state.changedConfigs }; /* return state.changedConfigs; */ },
  },
  actions: {
    obtainToken(type, payload: any) {

      const self = this;

      console.log("attempting to perform login: ", window.VUE_BMOS_WEB_API + '/ui');

      const logMe = new HaystackLogin(window.VUE_BMOS_WEB_API + '/ui', payload['username'], payload['password'], true);

      return new Promise((resolve, reject) => {

          logMe.login((headers: any) => {
            console.log('success: Authorization: ' + headers['Authorization']);
            const parts = headers['Authorization'].split('authToken=');

            if (parts.length > 0 && parts[1].length > 1) {
              self.commit('updateToken', parts[1]);
              resolve(parts[1]);
            } else {
              console.warn('Invalid Authorization');
              return reject('Invalid Authorization');
            }

          }, (msg: string) => {
            console.warn('Failed: ' + msg);
            return reject(msg);
          });
        });
    },
    async refreshToken(type, payload: any) {

      const self = this;

      if (!this.getters.isAuthenticated) {
        return;
      }

      const headers = self.getters.DefaultHeaders;
      const response = await axios.get(window.VUE_BMOS_WEB_API + '/refresh_token', headers);

      if (response.data !== undefined && response.data !== null) {

        //debugger;

        self.commit('updateToken', response.data);

        return response.data;
      }
    },
    logOut(context) {
      this.cache.clear();
      context.commit('removeToken');
      localStorage.removeItem('site_group');
      context.commit('setLayout', 'login-layout');
    },
    async setUpDefaultUserSiteGroup(context, user: IHaystackUser) {

      const self = this;

      let current_site_group: ISiteGroup | undefined = self.getters.CurrentSiteGroup;
  
      this.cache.clear();

      if (current_site_group !== undefined) {
        self.commit('setCurrentSiteGroup', current_site_group);
        return;
      }
  
      // Could be admin here if so the will be no groups defined
      if (user.is_admin === 'T') {
        // Just select first site_group by default
        const all_site_groups: ISiteGroup[] = await self.dispatch('requestSiteGroups');
        current_site_group = all_site_groups[0];
      }
      else {
        // Pick the first site group configure for user
        current_site_group = user.site_groups[0];
      }
  
      self.commit('setCurrentSiteGroup', current_site_group);
    },
    verifyToken() {
      return this.getters.isAuthenticated;
    },
    setBmosIds(context, ids: []) {
      context.commit('setBmosIds', ids);
    },
    setHaystackTags(context, tags: []) {
      context.commit('setHaystackTags', tags);
    },
    setAggregate(context, aggregate: string) {
      context.commit('setAggregate', aggregate);
    },
    setResolution(context, resolution: string) {
      context.commit('setResolution', resolution);
    },
    setStartDate(context, startDate: string) {

      context.commit('setStartDate', startDate);
    },
    setEndDate(context, endDate: string) {

      context.commit('setEndDate', endDate);
    },
    setAdjustForRooms(context, val: boolean) {

      context.commit('setAdjustForRooms', val);
    },
    async requestNamespaceRefMap(context, filters = {}) {

      const self = this;
      const { siteRefFilter, equipRefFilter } = filters;

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" action:"ref_namespace_map"\n';
      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      const namespace_map: Map<string, IRefInfo> = new Map();

      if (response.data !== undefined && response.data !== null) {

        const lines = response.data.split('\n').slice(2);

        console.log(response.data);

        for (const line of lines) {

          const fields = common.parseCSVIntoArraysOfFields(line)[0];

          const carnego_importer = strip_surrounding_quotes(fields[0]);
          const namespace = strip_surrounding_quotes(fields[1]);
          const reference = strip_surrounding_quotes(fields[2]);
          const name = strip_surrounding_quotes(fields[3]);
          const project_name = strip_surrounding_quotes(fields[4]);
          const dis = strip_surrounding_quotes(fields[5]);
          const hisTotalized = (fields[6] === 'N' || fields[6] === 'false' || fields[6] === 'f' || fields[6] === 'F') ? false : true;
          const carnego_organisation_ref = strip_surrounding_quotes(fields[7]);
          const carnego_site_group_ref = strip_surrounding_quotes(fields[8]);
          const site_ref = strip_surrounding_quotes(fields[9]);
          const equip_ref = strip_surrounding_quotes(fields[10]);
          const organisation_namespace = strip_surrounding_quotes(fields[11]);
          const site_group_namespace = strip_surrounding_quotes(fields[12]);
          const site_namespace = strip_surrounding_quotes(fields[13]);
          const equip_namespace = strip_surrounding_quotes(fields[14]);
          const start_datetime = strip_surrounding_quotes(fields[15]);
          const carnego_ip = strip_surrounding_quotes(fields[16]);
  
          // Filter entries based on optional parameters
          if ((equipRefFilter !== undefined) && equip_ref !== equipRefFilter) {
            continue;
          }

          if ((siteRefFilter !== undefined) && site_ref !== siteRefFilter) {
            continue;
          }

          const point_tags = JSON.parse(strip_surrounding_quotes(base64url.decode(fields[17])));
          const site_group_tags = JSON.parse(strip_surrounding_quotes(base64url.decode(fields[18])));
          const site_tags = JSON.parse(strip_surrounding_quotes(base64url.decode(fields[19])));
          const equip_tags = JSON.parse(strip_surrounding_quotes(base64url.decode(fields[20])));

          namespace_map.set(namespace, {carnego_importer: carnego_importer, ref: reference, name: name, dis: dis, carnego_organisation_ref: carnego_organisation_ref,
                            project_name: project_name, carnego_site_group_ref: carnego_site_group_ref,
                            equip_ref: equip_ref, site_ref: site_ref, namespace: namespace,
                            organisation_namespace: organisation_namespace,
                            site_group_namespace: site_group_namespace,
                            site_namespace: site_namespace, equip_namespace: equip_namespace, hisTotalized: hisTotalized,
                            start_datetime: start_datetime, carnego_ip: carnego_ip,
                            point_tags: point_tags, site_group_tags: site_group_tags, site_tags: site_tags, equip_tags: equip_tags
                          });
        }
      } else {
        console.error('requestNamespaceRefMap failed');
      }

      return namespace_map;
    },

    async requestLastValuesForSiteGroupRefMap(context, payload) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"ref_last_values_map_for_site_group"\nsite_group_ref\n%s\n';
      const zinc = sprintf(zinc_fmt, payload['carnego_site_group_ref']);

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      const ref_map: Map<string, IRefLastValue> = new Map();

      if (response.data !== undefined && response.data !== null) {

        const lines = response.data.split('\n').slice(2);

        for (const line of lines) {

          const fields = common.parseCSVIntoArraysOfFields(line)[0];

          // IRefLastValue
          const reference = strip_surrounding_quotes(fields[0]);
          const organisation_ref = strip_surrounding_quotes(fields[1]);
          const site_group_ref = strip_surrounding_quotes(fields[2]);
          const site_ref = strip_surrounding_quotes(fields[3]);
          const equip_ref = strip_surrounding_quotes(fields[4]);
          const organisation_namespace = strip_surrounding_quotes(fields[5]);
          const site_group_namespace = strip_surrounding_quotes(fields[6]);
          const site_namespace = strip_surrounding_quotes(fields[7]);
          const equip_namespace = strip_surrounding_quotes(fields[8]);
          const point_namespace = strip_surrounding_quotes(fields[9]);

          try {
            const dt =  DateTime.fromFormat(fields[10], "yyyy-MM-dd'T'HH:mm:ss.SSS z").toUTC();
            const value = parseFloat(fields[11]);

            // carnego_site_group_ref: '@' + self.selectedSiteGroup, requested_site_ref: self.site_ref, requested_equipemnt_ref: self.equip_ref};

            if ('requested_site_ref' in payload && payload['requested_site_ref'] !== site_ref ) {
              continue;
            }

            if ('requested_equipemnt_ref' in payload && payload['requested_equipemnt_ref'] !== equip_ref) {
              continue;
            }

            ref_map.set(reference, {ref: reference, organisation_ref: organisation_ref,
              site_group_ref: site_group_ref, site_ref: site_ref, equip_ref: equip_ref, organisation_namespace: organisation_namespace,
              site_group_namespace: site_group_namespace, site_namespace: site_namespace, equip_namespace: equip_namespace,
              point_namespace: point_namespace,
              timestamp: dt, value: value});

          }
          catch (e) {
            console.error(e);
            console.error(fields);
          }
        }
      }

      return ref_map;
    },
    async requestSiteGroups(context) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" action:"site_groups"\n';
      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      const projects: ISiteGroup[] = [];

      const prefix = 'yosemite.';

      if (response.data !== undefined && response.data !== null) {

        const lines = response.data.split('\n').slice(2);

        for (const line of lines) {

          if (line === '') {
            continue;
          }

          const fields = common.parseCSVIntoArraysOfFields(line)[0];

          const site_group_id = parseInt(fields[0], 10);
          const site_group_namespace = strip_surrounding_quotes(fields[1]);
          const site_group_settings = escaped_string_json_to_object(fields[2]);

	  let namespace = site_group_namespace;

	  // Check if the input string starts with the prefix.
          if (site_group_namespace.startsWith(prefix)) {
              // Remove the prefix using substring.
              namespace = site_group_namespace.substring(prefix.length);
          } 

          const project: ISiteGroup = {
            id: site_group_id,
            namespace: namespace,
            settings: site_group_settings,
          };

          projects.push(project);
        }
      }

      return projects;
    },
    // async requestFirstSiteGroup(context): Promise<ISiteGroup> {
    //   const site_groups = await this.cache.dispatch('requestSiteGroups');
    //   const site_group: ISiteGroup = site_groups[0];
    //   return site_group;
    // },
    async requestSiteGroupForId(context, site_group_id: number): Promise<ISiteGroup> {
      const site_groups = await this.cache.dispatch('requestSiteGroups');
      const site_group: ISiteGroup = site_groups.find((p: ISiteGroup) => p.id === site_group_id);
      return site_group;
    },
    async requestSiteGroupForNamespace(context, site_group_namespace: string): Promise<ISiteGroup> {
      const site_groups = await this.cache.dispatch('requestSiteGroups');
      const site_group: ISiteGroup = site_groups.find((p: ISiteGroup) => p.namespace === site_group_namespace);
      return site_group;
    },


    // curl -X POST https://carneab4.memset.net/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
    // --data $'ver:"3.0" id:@619265 action:"tags"\nparams\n[]\n'
    async request_haystack_tags(context, payload) {

      const self = this;

      const bmos_ids: string[] = payload['bmos_ids'];

      if (bmos_ids === null || bmos_ids === undefined || bmos_ids.length < 1) {
        return;
      }

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" id:[' + bmos_ids + '] action:"tags"\nparams\n[]\n';

      const tags: IPointHaystackTag[] = [];

      return axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers)
        .then((response) => {

          if (response.data !== undefined && response.data !== null) {

              const lines = response.data.split('\n').slice(2);
              for (const line of lines) {
                const fields = line.split(',');

                let point = fields[0];
                let key = fields[1];
                let value = fields[2];

                if (fields[0].startsWith('"') && fields[0].endsWith('"')) {
                    point = fields[0].substring(1, fields[0].length - 1);
                }

                if (fields[1].startsWith('"') && fields[1].endsWith('"')) {
                    key = fields[1].substring(1, fields[1].length - 1);
                }

                if (fields[2].startsWith('"') && fields[2].endsWith('"')) {
                    value = fields[2].substring(1, fields[2].length - 1);
                }

                tags.push({point: point, haystackkey: key, haystackvalue: value});
              }
          }

          return tags;
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            console.log(error.response.data);
            return [];
          }
        });
    },


    // curl -X POST https://carneab4.memset.net/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
    // --data $'ver:"3.0" id:@619265 action:"tags"\nparams\n[]\n'
    async request_haystack_tags_add(context, payload) {

      const self = this;

      const bmos_ids: string[] = payload['bmos_ids'];

      if (bmos_ids === null || bmos_ids === undefined || bmos_ids.length < 1) {
        return;
      }

      const tag_objects: Array<[string, string]> = payload['tags'];

      if (tag_objects === null || tag_objects === undefined || tag_objects.length < 1) {
        return;
      }

      let tags_strings: string[] = [];
      for (const t of tag_objects) {
        let s = t[0].concat('=>');
        s = s.concat(t[1]);
        tags_strings.push(s);
      }

      const tag_string: string = tags_strings.join(',');

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" id:[' + bmos_ids + '] action:"tags_add"\ntags\n["' + tag_string + '"]\n';

      const tags: IPointHaystackTag[] = [];

      return axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers)
        .then((response) => {

          return;
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            console.log(error.response.data);
            return;
          }
        });
    },

    async request_haystack_tags_delete(context, payload) {

      const self = this;

      const bmos_ids: string[] = payload['bmos_ids'];

      if (bmos_ids === null || bmos_ids === undefined || bmos_ids.length < 1) {
        return;
      }

      const tag_objects: Array<[string, string]> = payload['tags'];

      if (tag_objects === null || tag_objects === undefined || tag_objects.length < 1) {
        return;
      }

      let tags_strings: string[] = [];
      for (const t of tag_objects) {
        let s = t[0].concat('=>');
        s = s.concat(t[1]);
        tags_strings.push(s);
      }

      const tag_string: string = tags_strings.join(',');

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" id:[' + bmos_ids + '] action:"tags_delete"\ntags\n["' + tag_string + '"]\n';

      const tags: IPointHaystackTag[] = [];

      return axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers)
        .then((response) => {

          return;
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            console.log(error.response.data);
            return;
          }
        });
    },

    // curl -X POST http://127.0.0.1:1338/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
    // --data $'ver:"3.0" id:@619261 action:"yosemite_config"\nparams\n"test.vn_proto.ventive_home.occupancy_living_room"\n'
    async request_yosemite_config_get_site_groups(context, payload) {

      // zinc_fmt = 'ver:"3.0" action:"yosemite_config"\nnamespace,ignore_children\n"%s",%s\n'
      // zinc = zinc_fmt % (namespace, ignore_children)

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" action:"yosemite_config_site_groups"\n';
   
      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      if (response.data !== undefined && response.data !== null) {

        console.log(response);

        const site_groups = response.data.split('\n');
   
        console.log(site_groups);

        return site_groups;
      }

      return {};
    },

    // curl -X POST http://127.0.0.1:1338/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
    // --data $'ver:"3.0" id:@619261 action:"yosemite_config"\nparams\n"test.vn_proto.ventive_home.occupancy_living_room"\n'
    async request_yosemite_config_filtered_by_namespace(context, payload) {

      // zinc_fmt = 'ver:"3.0" action:"yosemite_config"\nnamespace,ignore_children\n"%s",%s\n'
      // zinc = zinc_fmt % (namespace, ignore_children)

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const namespace = payload['namespace'];

      const zinc_fmt = 'ver:"3.0" action:"yosemite_config"\namespace,ignore_children\n"%s",F\n';
      const zinc = sprintf(zinc_fmt, namespace);

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      if (response.data !== undefined && response.data !== null) {

        console.log(response);

        const json_str_with_quotes_array = response.data.split('\n').slice(2);
        const json_str_with_quotes = json_str_with_quotes_array[0];
        // let json_str = strip_surrounding_quotes(json_str_with_quotes);
        // console.log(json_str);
        // debugger;

        const json = escaped_string_json_to_object(json_str_with_quotes);

        // const json = JSON.parse(json_str);
        // debugger;
        return json;
      }

      return {};
    },

    async merge_yosemite_config(context, payload) {

      // zinc_fmt = 'ver:"3.0" action:"yosemite_config"\nnamespace,ignore_children\n"%s",%s\n'
      // zinc = zinc_fmt % (namespace, ignore_children)

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const json_encoded = encode(payload['json']);

      // action/ -H "authorization: BEARER authToken=****" --data $'ver:"3.0"
      // action:"yosemite_config_merge"\njson\n"{\"melius_nch_keswick\":{\"sites\":{\"name\":\"NCH-11-TWT\",\"enable\":true,\"plot\":\"K3\"}}}"\n'

      const zinc_fmt = 'ver:"3.0" action:"yosemite_config_merge"\njson\n"%s"\n';
      const zinc = sprintf(zinc_fmt, json_encoded);

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      // if (response.data !== undefined && response.data !== null) {

        // const json_str_with_quotes_array = response.data.split('\n').slice(2);
        // const json_str_with_quotes = json_str_with_quotes_array[0];
        // const json = escaped_string_json_to_object(json_str_with_quotes);

        // return json;
      // }

      return {};
    },

    async requestApps(context) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" action:"apps"\n';
      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      const apps: IApp[] = [];

      if (response.data !== undefined && response.data !== null) {

        const lines = response.data.split('\n').slice(2);

        for (const line of lines) {

          const fields = common.parseCSVIntoArraysOfFields(line)[0];

          const app_id = fields[0];
          const app_name = strip_surrounding_quotes(fields[1]);

          const app: IApp = {
            id: app_id,
            name: app_name,
          };


          apps.push(app);
        }
      }

      return apps;
    },
    async requestUserInfo(context) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc = 'ver:"3.0" action:"userinfo"\n';
      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      if (response.data !== undefined && response.data !== null) {

        const fields = common.parseCSVIntoArraysOfFields(response.data)[2];

        const apps = escaped_string_json_to_object(fields[7]);
        const site_groups = escaped_string_json_to_object(fields[8]);

        const user: IHaystackUser = {
          id: fields[0],
          username: fields[1].substring(1, fields[1].length - 1),
          email: fields[2].substring(1, fields[2].length - 1),
          is_admin: fields[3],
          user_type: fields[4].substring(1, fields[4].length - 1),
          avatar: fields[5].substring(1, fields[5].length - 1),
          root_ref: fields[6].substring(1, fields[6].length - 1),
          apps: apps,
          site_groups: site_groups,
          site_ids: escaped_string_json_to_object(fields[9])
        };

        self.commit('setLayout', 'default-layout');

        // if (user.is_admin === 'T') {
        //   self.commit('setLayout', 'default-layout');
        // } else {
        //   const project = await self.cache.dispatch('requestSiteGroupForId', user.project_id);
        //   const project_name = project.name;
        //   console.log(project_name);
        //   self.commit('setLayout', project_name + '-layout');
        // }

        return user;
      }

      return false;
    },

    async getRefsFromNamespaces(context, namespaces: string[]) {

      const self = this;

      const namespace_map: Map<string, IRefInfo> = await self.cache.dispatch('requestNamespaceRefMap');

      const values: Map<string, IRefInfo> = new Map();

      for (const namespace of namespaces) {

        const ref: IRefInfo | undefined = namespace_map.get(namespace);

        if (ref !== undefined) {
          values.set(namespace, ref);
        }
      }

      return values;
    },

    // Returns map of namespace -> refInfo
    async getRefsFromSiteGroupSitesAndNames(context, payload) {

      const self = this;

      // const requested_site_group_namespace = payload['requested_site_group_namespace'];
      const point_names = payload['point_names'];

      const namespace_map: Map<string, IRefInfo> = await self.cache.dispatch('requestNamespaceRefMap');

      const name_campus_map: Map<[string, string, string, string, string, string], IRefInfo>
        = new Map(Array.from(namespace_map, (entry) => [[entry[1].carnego_organisation_ref, entry[1].carnego_site_group_ref, entry[1].site_group_namespace,
                                                         entry[1].site_ref, entry[1].equip_ref, entry[1].name], entry[1]]));

      const values: Map<string, IRefInfo> = new Map();

      for (const [key, value] of name_campus_map) {

        const carnego_organisation_ref = key[0];
        const carnego_site_group_ref = key[1];
        const site_group_namespace = key[2];
        const site = key[3];
        const equipment = key[4];
        const name = key[5];

        if ('carnego_organisation_ref' in payload && !carnego_organisation_ref.includes(payload['carnego_organisation_ref'])) {
          continue;
        }

        if ('carnego_site_group_ref' in payload && !carnego_site_group_ref.includes(payload['carnego_site_group_ref'])) {
          continue;
        }

        if ('requested_site_group_namespace' in payload && !site_group_namespace.includes(payload['requested_site_group_namespace'])) {
          continue;
        }

        if ('requested_site_ref' in payload && payload['requested_site_ref'] !== site) {
          continue;
        }

        if ('requested_equipemnt_ref' in payload && payload['requested_equipemnt_ref'] !== equipment) {
          continue;
        }

        if ('point_names' in payload && !payload['point_names'].includes(name)) {
          continue;
        }

        values.set(value.namespace, value);
      }

      return values;
    },

    async requestSitesRefsForSiteGroup(context, site_group_namespaces: string[]) {

      const self = this;

      // s = yosemite.melius_nch_keswick
      // list = ['melius_nch_keswick', 'melius_nch_camdem']
      function any_strings_included_in(list: string[], s: string): boolean {

        // if (s.includes('melius')) {
        //   debugger;
        // }

        if (list === undefined || list === null) {
          return false;
        }

        if (!Array.isArray(list)) {
          return false;
        }

        const filtered = list.filter((item) => s.includes(item));

        return filtered.length > 0;
      }

      const namespace_map: Map<string, IRefInfo> = await self.cache.dispatch('requestNamespaceRefMap');
      // const campus_refs = Array.from(namespace_map.values()).filter((r)
      //   => r.site_group_namespace.includes(site_group_namespace)).map((i) => i.site_ref);

      const campus_refs = Array.from(namespace_map.values()).filter((r) => any_strings_included_in(site_group_namespaces, r.site_group_namespace)).map((i) => i.site_ref);

      const campus_site_refs = [...new Set(campus_refs)]; // Do a unique

      return campus_site_refs;
    },

    async requestSiteInfoForSiteGroup(context, site_group_namespaces: string[]) {

      const self = this;

      // const site_refs = await self.cache.dispatch('requestSitesRefsForSiteGroup', site_group_namespace );

      const site_refs = await self.cache.dispatch('requestSitesRefsForSiteGroup', site_group_namespaces );

      const site_refs_str = array_to_string(site_refs);

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"siteinfo"\nsite_ref\n%s\n';
      const zinc = sprintf(zinc_fmt, site_refs_str);

      // "ver:"3.0" action:"siteinfo"
      // site_ref
      // [@293,@740,@434,@695,@199,@526,@152,@481,@573,@246,@340,@665,@387]
      // "

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      if (response.data !== undefined && response.data !== null) {

        const total_map: Map<string, Map<string, string>> = new Map();

        const lines = response.data.split('\n').slice(2);
        for (const line of lines) {
          const fields = line.split(',');

          const reference = strip_surrounding_quotes(fields[0]);
          const value_str = strip_surrounding_quotes(fields[1]);

          const pairs = value_str.split(';');

          const tag_map: Map<string, string> = new Map();
          for (const pair of pairs) {
            const tag: string[] = pair.split('=>');
            tag_map.set(tag[0], tag[1]);
          }

          total_map.set(reference, tag_map);
        }

        return total_map;
      }
    },

    async requestSiteInfo(context, site_ref: string) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"siteinfo"\nsite_ref\n%s\n';
      const zinc = sprintf(zinc_fmt, site_ref);

      // "ver:"3.0" action:"siteinfo"
      // site_ref
      // [@293,@740,@434,@695,@199,@526,@152,@481,@573,@246,@340,@665,@387]
      // "
      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      if (response.data !== undefined && response.data !== null) {

        const total_map: Map<string, string> = new Map();

        const lines = response.data.split('\n').slice(2);
        for (const line of lines) {
          const fields = line.split(',');

          const reference = strip_surrounding_quotes(fields[0]);
          const value_str = strip_surrounding_quotes(fields[1]);

          const pairs = value_str.split(';');

          for (const pair of pairs) {
            const tag: string[] = pair.split('=>');
            total_map.set(tag[0], tag[1]);
          }
        }

        return total_map;
      }
    },

    async requestStatsForTimespan(context, payload) {

      const self = this;

      const refs_str = array_to_string(payload['references']);

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"statistics_for_timespan"\nid,range\n%s,"%s"\n';
      const zinc = sprintf(zinc_fmt, refs_str, payload['start_date']);

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      const stat_map: Map<string, IStatForTimespan> = new Map();

      if (response.data !== undefined && response.data !== null) {

        const lines = response.data.split('\n').slice(2);
        for (const line of lines) {
          const fields = line.split(',');

          const reference = strip_surrounding_quotes(fields[0]);

          const stat: IStatForTimespan = {reference: reference,
                                   number_of_values: parseInt(fields[1], 10),
                                   number_of_values_non_zero: parseInt(fields[2], 10),
                                   average_value: parseFloat(fields[3]),
                                   average_value_non_zero: parseFloat(fields[4]),
                                   average_of_daily_differences: parseFloat(fields[5]),
                                   average_of_daily_differences_non_zero: parseFloat(fields[6]),
                                   min_value: parseFloat(fields[7]),
                                   min_value_non_zero: parseFloat(fields[8]),
                                   min_of_daily_differences: parseFloat(fields[9]),
                                   min_of_daily_differences_non_zero: parseFloat(fields[10]),
                                   max_value: parseFloat(fields[11]),
                                   max_of_daily_differences: parseFloat(fields[12]),
                                   max_of_daily_differences_non_zero: parseFloat(fields[13]),
                                  };

          stat_map.set(reference, stat);

        }

        return stat_map;
      }
    },

    async requestDailyStats(context, payload) {

      const self = this;

      const refs_str = array_to_string(payload['references']);

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"monthly_statistics"\nid,range\n%s,"%s"\n';
      const zinc = sprintf(zinc_fmt, refs_str, payload['start_date']);

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

      const stat_map: Map<string, IMonthlyStat[]> = new Map();

      if (response.data !== undefined && response.data !== null) {

        console.log('got requestDailyStats data');

        const lines = response.data.split('\n').slice(2);
        for (const line of lines) {
          const fields = line.split(',');

          const reference = strip_surrounding_quotes(fields[0]);

          const stat: IMonthlyStat = {reference: reference,
                                   month: fields[1],
                                   number_of_days: parseInt(fields[2], 10),
                                   sum_of_daily_differences: parseFloat(fields[3]),
                                   sum_of_max_daily_values: parseFloat(fields[4]),
                                   average_of_daily_differences: parseFloat(fields[5]),
                                   average_of_max_daily_values: parseFloat(fields[6]),
                                   min_of_min_daily_values: parseFloat(fields[7]),
                                   max_of_max_daily_values: parseFloat(fields[8]),
                                  };

          let tmp = stat_map.get(reference);

          if (tmp === undefined) {
            stat_map.set(reference, []);
            tmp = stat_map.get(reference);
          }

          if (tmp === undefined) {
            continue;
          }

          tmp.push(stat);

          stat_map.set(reference, tmp);

        }

        return stat_map;
      }
    },

    async requestStaticFile(context, payload) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const response = await axios.get(window.VUE_BMOS_WEB_API + '/static_data/performance.csv', headers);

      if (response.data !== undefined && response.data !== null) {

        // console.log('got requestDailyStats data');

        // const lines = response.data.split('\n').slice(2);
        // for (const line of lines) {
        //   const fields = line.split(',');

        //   const reference = strip_surrounding_quotes(fields[0]);

        //   const stat: IMonthlyStat = {reference: reference,
        //                            month: fields[1],
        //                            number_of_days: parseInt(fields[2], 10),
        //                            sum_of_daily_differences: parseFloat(fields[3]),
        //                            sum_of_max_daily_values: parseFloat(fields[4]),
        //                            average_of_daily_differences: parseFloat(fields[5]),
        //                            average_of_max_daily_values: parseFloat(fields[6]),
        //                            min_of_min_daily_values: parseFloat(fields[7]),
        //                            max_of_max_daily_values: parseFloat(fields[8]),
        //                           };

        //   let tmp = stat_map.get(reference);

        //   if (tmp === undefined) {
        //     stat_map.set(reference, []);
        //     tmp = stat_map.get(reference);
        //   }

        //   if (tmp === undefined) {
        //     continue;
        //   }

          // tmp.push(stat);

          // stat_map.set(reference, tmp);

       // }

        return response.data;
      }
    },

    async requestStaticFileForSiteGroupId(context, payload) {

      const self = this;

      // const site_group_id = payload["site_group_id"];

      // https://bmos.carnegosystems.net/static_data/scheduler/performance_generator/13/performance.json
      // const url = https://bmos.carnegosystems.net/static_data/scheduler/performance_generator/13/performance.json

      let current_site_group: ISiteGroup | undefined = self.getters.CurrentSiteGroup;

      // console.log(payload);

      const url_fmt = '/static_data/scheduler/%s/%s/%s';
      const url = sprintf(url_fmt, payload["product"], current_site_group?.id, payload["filename"]);

      // alert(url);
      // console.log(url);

      const headers = self.getters.DefaultHeaders;

      try {
        const response = await axios.get(window.VUE_BMOS_WEB_API + url, headers);

        if (response.data !== undefined && response.data !== null) {

          // console.log('got requestDailyStats data');

          // const lines = response.data.split('\n').slice(2);
          // for (const line of lines) {
          //   const fields = line.split(',');

          //   const reference = strip_surrounding_quotes(fields[0]);

          //   const stat: IMonthlyStat = {reference: reference,
          //                            month: fields[1],
          //                            number_of_days: parseInt(fields[2], 10),
          //                            sum_of_daily_differences: parseFloat(fields[3]),
          //                            sum_of_max_daily_values: parseFloat(fields[4]),
          //                            average_of_daily_differences: parseFloat(fields[5]),
          //                            average_of_max_daily_values: parseFloat(fields[6]),
          //                            min_of_min_daily_values: parseFloat(fields[7]),
          //                            max_of_max_daily_values: parseFloat(fields[8]),
          //                           };

          //   let tmp = stat_map.get(reference);

          //   if (tmp === undefined) {
          //     stat_map.set(reference, []);
          //     tmp = stat_map.get(reference);
          //   }

          //   if (tmp === undefined) {
          //     continue;
          //   }

            // tmp.push(stat);

            // stat_map.set(reference, tmp);

        // }

          return response.data;
        }
      }
      catch (e) {
        return null;
      }
    },

    // curl -X POST http://carneab4.memset.net:1338/hisRead -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5"
    // --data $'ver:"3.0" granularity:"second" aggregate:"avg"\nid,range\n[@9941983, @9941936],"2020-09-02"'
    // refs: IRefInfo[], granularity: string, date_range: string
    // If passed references are isTotalised and not isTotalised two call are made
    async requestDataForNamespaces(context, payload) {

      const self = this;

      const namespace_map: Map<string, IRefInfo> = await self.cache.dispatch('requestNamespaceRefMap');
      const ref_map: Map<string, string> = new Map(Array.from(namespace_map, (entry) => [entry[1].ref, entry[0]]));

      const namespaces = payload['namespaces'];
      const granularity = payload['granularity'];
      const date_range = payload['date_range'];

      const data_map: Map<string, IDataValue[]> = new Map();

      const headers = self.getters.DefaultHeaders;

      let string_array = '[';

      for (const namespace of namespaces) {

        const ref: IRefInfo | undefined = namespace_map.get(namespace);

        if (ref !== undefined && ref.hisTotalized === true) {
          string_array = string_array.concat(ref.ref);
          string_array = string_array.concat(',');
        }
      }

      string_array = string_array.substring(0, string_array.length - 1);
      string_array = string_array.concat(']');

      if (string_array.length > 1) { // Not refs having hisTotalized
        const zinc1_fmt = 'ver:"3.0" aggregate:"diff" granularity:"%s"\nid,range\n%s,"%s"\n';

        const zinc1 = sprintf(zinc1_fmt, granularity, string_array, date_range);

        const increasing_data = await axios.post(window.VUE_BMOS_WEB_API + '/hisRead', zinc1, headers);

        if (increasing_data !== undefined && increasing_data.data !== null) {
          parse_hist_read_data_into_map(increasing_data.data, ref_map, data_map);
        }
      }

      string_array = '[';

      for (const namespace of namespaces) {

        const ref: IRefInfo | undefined = namespace_map.get(namespace);

        if (ref !== undefined && ref.hisTotalized === false) {
          string_array = string_array.concat(ref.ref);
          string_array = string_array.concat(',');
        }
      }

      string_array = string_array.substring(0, string_array.length - 1);
      string_array = string_array.concat(']');

      if (string_array.length > 1) { // Not refs having hisTotalized
        const zinc2_fmt = 'ver:"3.0" aggregate:"avg" granularity:"%s"\nid,range\n%s,"%s"\n';

        const zinc2 = sprintf(zinc2_fmt, granularity, string_array, date_range);

        const data = await axios.post(window.VUE_BMOS_WEB_API + '/hisRead', zinc2, headers);

        if (data !== undefined && data.data !== null) {
          parse_hist_read_data_into_map(data.data, ref_map, data_map);
        }
      }

      return data_map;
    },

    // async requestPortfolioPointsForSiteGroup(context, requested_site_group_ref: string) {

    //   const self = this;
    //   const userInfo = await self.cache.dispatch('requestUserInfo');
    //   const projectInfo: ISiteGroup = await self.dispatch('requestSiteGroupForId', userInfo.project_id);
    //   const points: Map<string, IProfileSitePoints> = new Map();

    //   const project_campus_name = projectInfo.settings['campus_name'];
    //   const profile_points: IProfilePoints = projectInfo.settings['profile_points'];

    //   const profile_point_type: Map<string, string> = new Map();
    //   const profile_all_point_names: string[] = [];

    //   // key will be like appliance_points value an array []
    //   for (const [key, values] of Object.entries(profile_points)) {
    //     for (const point_name of values) {
    //       profile_all_point_names.push(point_name);
    //       profile_point_type.set(point_name, key);
    //     }
    //   }

    //   const headers = self.getters.DefaultHeaders;

    //   const zinc_fmt = 'ver:"3.0"\nfilter\n"point and equipRef->siteRef->carnego_site_group_ref == %s\"\n';
    //   const zinc = sprintf(zinc_fmt, requested_site_group_ref);

    //   return axios
    //     .post(window.VUE_BMOS_WEB_API + '/read2', zinc, headers)
    //     .then((response) => {
    //       if (response.data !== undefined && response.data !== null) {
    //         const lines = response.data.split('\n').slice(2);

    //         for (const line of lines) {
    //           const fields = line.split(',');

    //           const reference = fields[0];
    //           const namespace = strip_surrounding_quotes(fields[1]);
    //           const dis = strip_surrounding_quotes(fields[1]);
    //           const equip_ref = fields[3];
    //           const site_ref = fields[4];
    //           const site_group_ref = fields[5];
    //           const project_ref = fields[6];
    //           const organisation_ref = fields[7];

    //           // bryn_bragl.bb2012.pkom4.max_control_voltage_duct_heater
    //           const parts = namespace.split('.');
    //           const point = parts[3];

    //           if (profile_all_point_names.includes(point)) {

    //             const profile_type = profile_point_type.get(point);

    //             if (profile_type === undefined) {
    //               continue;
    //             }

    //             if (!points.has(site_ref)) {
    //               points.set(site_ref, { site_ref: site_ref, appliance_points: [], comfort_points: [], heating_points: [], hotwater_points: [] });
    //             }

    //             const tmp_site: IProfileSitePoints | undefined = points.get(site_ref);

    //             if (tmp_site === undefined) {
    //               continue;
    //             }

    //             if (profile_type === 'appliance_points') {
    //               tmp_site['appliance_points'].push({ ref: reference, name: point });
    //             }

    //             if (profile_type === 'comfort_points') {
    //               tmp_site['comfort_points'].push({ ref: reference, name: point });
    //             }

    //             if (profile_type === 'heating_points') {
    //               tmp_site['heating_points'].push({ ref: reference, name: point });
    //             }

    //             if (profile_type === 'hotwater_points') {
    //               tmp_site['hotwater_points'].push({ ref: reference, name: point });
    //             }
    //           }
    //         }
    //       }

    //       return points;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       if (error.response) {
    //         console.log(error.response.data);
    //         return false;
    //       }
    //     });
    // },

    // curl -X POST http://127.0.0.1:1338/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5" --data $'ver:"3.0" action:"modbus"\n'

    // curl -X POST http://127.0.0.1:1338/action/ -H "authorization: BEARER authToken=PKLivoIgkH390hiKHOAutagi2Emfd5" --data $'ver:"3.0" action:"modbus"\nvalue\n22\n'
    // async requestSetModbus(context, payload) {

    //   if (payload === undefined) {
    //     return;
    //   }

    //   const self = this;

    //   const headers = self.getters.DefaultHeaders;

    //   // Make sure value is floating point format
    //   let val = payload['value'].toFixed(1);

    //   const zinc_fmt = 'ver:"3.0" action:"modbus"\nhost, port, uid, register, holding, value\n"%s", %s, %s, %s, %s, %s\n';
    //   const zinc = sprintf(zinc_fmt, payload['host'], payload['port'], payload['uid'], payload['register'], payload['holding'], val);

    //   console.log('requestSetModbus', zinc);

    //   const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);

    //   if (response.data !== undefined && response.data !== null) {

    //     // ver:"3.0"
    //     // value
    //     // 21

    //     const lines = response.data.split('\n').slice(2);
    //     const val = lines[0];
    //     return val;
    //   }
    // },
    async requestSetModbus(context, payload) {

      if (payload === undefined) {
        return;
      }

      const self = this;

      const headers = self.getters.DefaultHeaders;

      // Make sure value is floating point format
      let val = payload['value'].toFixed(1);

      const zinc_fmt = 'ver:"3.0" action:"modbus"\nhost, port, uid, register, holding, value\n"%s", %s, %s, %s, %s, %s\n';
      const zinc = sprintf(zinc_fmt, payload['host'], payload['port'], payload['uid'], payload['register'], payload['holding'], val);

      console.log('requestSetModbus', zinc);

      return axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);
    },

    // async requestGetModbus(context, payload) {

    //   if (payload === undefined) {
    //     return undefined;
    //   }
      
    //   const self = this;

    //   const headers = self.getters.DefaultHeaders;

    //   // const zinc_fmt = 'ver:"3.0" action:"modbus"\nhost, port, uid, register, holding\n"%s", %s, %s, %s, %s\n';
    //   // const zinc = sprintf(zinc_fmt, payload['host'], payload['port'], payload['uid'], payload['register'], payload['holding']);

    //   const zinc_fmt = 'ver:"3.0" action:"modbus"\nhost, port, uid, register, holding\n"%s", %s, %s, %s, %s\n';
    //   const zinc = sprintf(zinc_fmt, payload['host'], payload['port'], payload['uid'], payload['register'], payload['holding']);

    //   console.log('requestGetModbus', zinc);

    //   return axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers)
    //     .then((response) => {

    //       if (response.data !== undefined && response.data !== null) {

    //              // ver:"3.0"
    //             // value
    //             // 21
    //             const lines = response.data.split('\n').slice(2);
    //             const val = lines[0];
    //             return val;
    //       }

    //       return 0.0;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       if (error.response) {
    //         console.log(error.response.data);
    //         return 0.0;
    //       }
    //     });
    // },

    async requestGetModbus(context, payload) {

      if (payload === undefined) {
        return undefined;
      }
      
      const self = this;

      const headers = self.getters.DefaultHeaders;

      // const zinc_fmt = 'ver:"3.0" action:"modbus"\nhost, port, uid, register, holding\n"%s", %s, %s, %s, %s\n';
      // const zinc = sprintf(zinc_fmt, payload['host'], payload['port'], payload['uid'], payload['register'], payload['holding']);

      const zinc_fmt = 'ver:"3.0" action:"modbus"\nhost, port, uid, register, holding\n"%s", %s, %s, %s, %s\n';
      const zinc = sprintf(zinc_fmt, payload['host'], payload['port'], payload['uid'], payload['register'], payload['holding']);

      console.log('requestGetModbus', zinc);

      return axios.post(window.VUE_BMOS_WEB_API + '/action', zinc, headers);
    },

    async requestScriptTemplates(context) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"script_templates"\n';

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc_fmt, headers);

      const scripts: IScript[] = [];

      if (response.data !== undefined && response.data !== null) {

        // ver:"3.0"
        // value
        // 21
        const lines = response.data.split('\n').slice(2);

        for (const line of lines) {

          const fields = common.parseCSVIntoArraysOfFields(line)[0];

          let toml_escaped = strip_surrounding_quotes(fields[1]);
          toml_escaped = base64url.decode(toml_escaped);

          // let toml_escaped = fields[1].replaceAll('\\n', '\n');
          // toml_escaped = fields[1].replaceAll('\\"', '"');

          // console.log(toml_escaped);

          const script: IScript = {
            name: strip_surrounding_quotes(fields[0]),
            toml: toml_escaped,
          };

          // debugger;

          scripts.push(script);
        }

        return scripts;
      }
    },


    async requestScriptInstances(context) {

      const self = this;

      const headers = self.getters.DefaultHeaders;

      const zinc_fmt = 'ver:"3.0" action:"script_instances"\n';

      const response = await axios.post(window.VUE_BMOS_WEB_API + '/action', zinc_fmt, headers);

      const scripts: IScriptInstance[] = [];

      if (response.data !== undefined && response.data !== null) {

        const lines = response.data.split('\n').slice(2);

        for (const line of lines) {

            const fields = common.parseCSVIntoArraysOfFields(line)[0];

            const id = fields[0];
            const name = strip_surrounding_quotes(fields[1]);
            const description = strip_surrounding_quotes(fields[2]);

            const script: IScriptInstance = {
              id: id,
              name: name,
              description: description,
            };

            scripts.push(script);
        }

        return scripts;
      }
    },


  },

});

axios.interceptors.request.use((config: any) => {

  const originalRequest: any = config;

  if (router.currentRoute.name === 'login') {

    if (!originalRequest.headers.hasOwnProperty('authorization')) {
      return config;
    }

    const auth = originalRequest.headers.authorization;

    console.log(auth);

    const parts = auth.split('authToken=');
    const token = parts[1];

    const token_parts = token.split('.');

    console.log(token_parts);

    const header = base64url.decode(token_parts[0]);
    const payload_str = base64url.decode(token_parts[1]);

    const payload = JSON.parse(payload_str);

    const now = new Date();
    const utc_timestamp_ms = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
    const utc_timestamp = Math.floor(utc_timestamp_ms / 1000);

    if (utc_timestamp > payload['exp']) {
      // router.replace({ name: 'login' });
    }

    // if we ever want a renewal of tokens
    // if (tokenIsExpired && path_is_not_login) {
    //   return issueToken().then((token) => {
    //     originalRequest['Authorization'] = 'Bearer ' + token;
    //     return Promise.resolve(originalRequest);
    //   });
    // }
  }

  return config;
}, (err) => {
  return Promise.reject(err);
});


// Add a response interceptor
axios.interceptors.response.use((response) => {
  // Do something with response data

  // if(response.status == 401 ) {
  //   auth.logout();
  //   router.go('/login?unauthorized=1');
  // }

  return response;
}, (error) => {

  if (error.response === undefined) {
      return Promise.reject(error);
  }

  if (error.response.status === 401) {

    store.dispatch('logOut');

    if (router.currentRoute.name !== 'login') {
      // router.replace({ name: 'login' });
      router.replace({ path: '/login' });
      // this.$router.replace({ path: '/login' });
    }
  }

  // Do something with response error
  return Promise.reject(error);
});


// Vue.prototype.$http = axios;
// Vue.prototype.axios = axios;
// Vue.prototype.axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

// import Vue from 'vue';
// import App from './App.vue';
// import router from './router';

// Vue.config.productionTip = false;

// Vue.use(VModal);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: false } });

// Vue.use(VueSimpleAlert);

Vue.prototype.$filters = {
  last: (array: any[]) => common.last(array),
  toFixed: (val: number, dp: number) => val.toFixed(dp)
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');


const refreshInterval = 60 * 1000; // 60 seconds

// Schedule token refresh every minute
setInterval(() => {
  store.dispatch('refreshToken')
    .then((newToken) => {
      console.log('Token refreshed:', newToken);
    })
    .catch((error) => {
      console.error('Token refresh error:', error);
    });
}, refreshInterval);
